/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default [
  {
    url: '/',
    name: 'Dashboard',
    slug: 'dashboard',
    icon: 'HomeIcon'
    // submenu: [
    //   {
    //     url: '/dashboard/onsite',
    //     name: 'Onsite',
    //     slug: 'dashboard-onsite'
    //   },
    //   {
    //     url: '/dashboard/team',
    //     name: 'Team',
    //     slug: 'dashboard-team'
    //   }
    // ]
  },
  {
    url: '/contacts',
    name: 'Contacts',
    slug: 'contacts',
    icon: 'UserIcon'
  },
  {
    url: '/locations',
    name: 'Locations',
    slug: 'locations',
    icon: 'MapIcon',
    permission: 'role:loc_role_admin|user_admin'
  },
  {
    url: '/devices',
    name: 'Devices',
    slug: 'devices',
    icon: 'MonitorIcon',
    permission: 'role:loc_role_admin|user_admin'
  },
  {
    url: '/settings',
    name: 'Settings',
    slug: 'settnigs',
    icon: 'SettingsIcon',
    permission: 'edit:settings'
  },
  {
    url: '/users',
    name: 'Users',
    slug: 'users',
    icon: 'UsersIcon',
    permission: 'list:users'
  }
]
